import {
  ChangeEvent,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";

import { MuiTelInputInfo } from "mui-tel-input";

import { UseTextFieldParams } from "./PhoneField.types";

export const usePhoneField = <R>({
  ref,
  defaultValue,
  value,
  onChangeEvent,
  onChange,
}: UseTextFieldParams<R>) => {
  const textfieldRef = useRef<HTMLDivElement | null>(null);
  const [state, setState] = useState<string>(
    (value ?? defaultValue ?? "") as unknown as string
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useImperativeHandle(
    ref,
    (() => {
      return {
        instance: textfieldRef.current,
        value: state,
        setValue: (v: string) => {
          setState(v);
        },
        reset: () => {
          setState("");
        },
      };
    }) as unknown as () => R,
    [state]
  );

  const onChangeHandler = (event: string, info: MuiTelInputInfo) => {
    // onChangeEvent?.(event);
    if (typeof value === "undefined") {
      setState(event);
    }
    onChange?.(JSON.stringify({ ...info, numberValue: event }));
  };

  const onClearStateHandler = () => {
    if (typeof value === "undefined") {
      setState("");
    }
    onChange?.("");
  };

  const valueState = useMemo(
    () =>
      (typeof value !== "undefined" && typeof value === "string" && value
        ? JSON.parse(value)?.numberValue
        : state) as string,
    [value, state]
  );

  return {
    textfieldRef,
    valueState,
    onChangeHandler,
    onClearStateHandler,
  };
};
